import React, { useState, useEffect } from 'react';
import './AcademicBank.css';
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';

const AcademicBank = () => {
  const [academicData, setAcademicData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    const fetchAcademicData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/academic_bank");
        const data = response.data;

        // Banner Images → prepend process.env
        const rawImages = data?.banner?.images || [];
        const formattedImages = rawImages.map(img =>
  img ? `/${img.replace(/^\//, "")}` : null
);


        data.banner.images = formattedImages;

        // Section Images → use SAME logic
        const formatSectionImages = (sections) => {
          if (!sections) return sections;

          Object.keys(sections).forEach(sectionKey => {
            sections[sectionKey].forEach(item => {
              if (!item.image) return;

              item.image = `${process.env.REACT_APP_API_URL}/public/${item.image.replace(/^\//, "")}`;
            });
          });

          return sections;
        };

        if (data.sections) {
          formatSectionImages(data.sections);
        }

        setAcademicData(data);
        setIsLoading(false);

      } catch (err) {
        console.error("Error fetching Academic Bank data:", err);
        setError("Failed to load Academic Bank data");
        setIsLoading(false);
      }
    };

    fetchAcademicData();
  }, []);

  const toggleSection = (sectionIndex) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionIndex]: !prev[sectionIndex]
    }));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !academicData) {
    return <div>{error}</div>;
  }

  const bannerData = academicData.banner || {};
  const mainHeading = academicData.main_heading || "";
  const sections = academicData.sections || {};
  const cards = academicData.cards || {};

  const bannerTitle = bannerData.heading || "";
  const bannerImages = bannerData.images || [];
   const mobile_images=bannerData.mobile_images || [];

  const cardItems = Object.values(cards);

  return (
    <>

      {bannerImages.length > 0 && (
        <DynamicBanner
          title={bannerTitle}
          bgImage={bannerImages}
          bgImageMobile={mobile_images}
        />
      )}

      <section className="academic-bank-section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{mainHeading}</h2>
          </div>

          {Object.keys(sections).map((sectionKey, sectionIndex) => {
            const sectionItems = sections[sectionKey];

            return sectionItems.map((item, itemIndex) => {
              const fullIndex = `${sectionIndex}-${itemIndex}`;
              const isExpanded = expandedSections[fullIndex];

              const hasImage = !!item.image;

              const imageOrderClass =
                item.position === "left"
                  ? "order-1 order-md-1"
                  : "order-1 order-md-2";

              const textOrderClass =
                item.position === "left"
                  ? "order-2 order-md-2"
                  : "order-2 order-md-1";

              return (
                <div
                  key={fullIndex}
                  className={`row mt-3 mt-md-5 ${hasImage ? "d-flex align-items-center" : ""}`}
                >

                  {/* IMAGE COLUMN */}
                  {item.image && (
                    <div className={`col-12 col-md-4 ${imageOrderClass}`}>
                      <img
                        src={item.image}
                        alt={item.heading}
                        className="img-fluid"
                        style={{ borderRadius: '10px' }}
                      />
                    </div>
                  )}

                  {/* CONTENT COLUMN */}
                  <div className={`${hasImage ? "col-12 col-md-8" : "col-12"} ${textOrderClass}`}>
                    <div className="sec-title py-3">
                      <h2>{item.heading}</h2>
                    </div>

                    {item.contenttextarea && (
                      <div
                        style={{ textAlign: 'justify' }}
                        dangerouslySetInnerHTML={{ __html: item.contenttextarea }}
                      />
                    )}

                    {item.readmoretextarea && (
                      <>
                        <div className={`collapse ${isExpanded ? 'show' : ''}`}>
                          <div
                            style={{ textAlign: 'justify' }}
                            dangerouslySetInnerHTML={{ __html: item.readmoretextarea }}
                          />
                        </div>

                        <button
                          className="readmoreall mt-2"
                          type="button"
                          onClick={() => toggleSection(fullIndex)}
                          aria-expanded={isExpanded}
                        >
                          {isExpanded ? 'Read Less' : (item.read_more_text || 'Read More')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            });
          })}

          {/* Cards */}
          {cardItems.length > 0 && (
            <div className="row g-3 mb-5 mt-5 justify-content-center">
              {cardItems.map((card, index) => (
                <div key={index} className="col-12 col-md-4">
                  <div className="portal-box">
                    <div className="icon-bank mb-2">
                      <i className={`fa ${card.icon || 'fa-globe'}`}></i>
                    </div>
                    <h6 className="mb-1">{card.heading}</h6>
                    {card.link && (
                      <a
                        href={card.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="small"
                      >
                        {card.link_text || card.link}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </section>
    </>
  );
};
export default AcademicBank;